import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import { formatDate } from '../../../../utlis';
import MyTable from '../../../../components/MyTable';

// Map API status to UI display
const mapRoleStatus = (status) => {
  if (!status) return { text: 'N/A', isActive: false };
  const statusUpper = status.toUpperCase();
  if (statusUpper === 'ACTIVE') {
    return { text: status, isActive: true };
  }
  return { text: status, isActive: false };
};

const UserRolesTable = ({ data, onEditRole, onDeleteRole, pageSize, onPageSizeChange }) => {
  // Transform data to ensure consistent field names
  const transformedData = data.map((role) => ({
    id: role.role_id || role.unique_id || '',
    role: role.role || '',
    divison: role.divison || '',
    description: role.description || '',
    access: role.access || '',
    created_by: role.created_by || '',
    created: role.created || '',
    updated_by: role.updated_by || '',
    updated: role.updated || '',
    status: role.status || '',
  }));

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        display: false,
      },
    },
    {
      name: 'role',
      label: 'Role',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0];
          return (
            <h3
              onClick={() => onEditRole(id)}
              className="text-base font-bold text-auxiliary-800 cursor-pointer hover:underline"
            >
              {value || 'N/A'}
            </h3>
          );
        },
      },
    },
    {
      name: 'divison',
      label: 'Division',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || 'N/A',
      },
    },
    {
      name: 'description',
      label: 'Description',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="truncate max-w-xs" title={value}>
            {value || 'N/A'}
          </p>
        ),
      },
    },
    {
      name: 'created_by',
      label: 'Created By',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || 'N/A',
      },
    },
    {
      name: 'created',
      label: 'Date Created',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (value ? formatDate(value) : 'N/A'),
      },
    },
    {
      name: 'updated_by',
      label: 'Updated By',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || 'N/A',
      },
    },
    {
      name: 'updated',
      label: 'Updated Date',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (value ? formatDate(value) : 'N/A'),
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const { text, isActive } = mapRoleStatus(value);
          return (
            <p
              className={`py-1 px-3 rounded-full text-center text-xs border ${
                isActive
                  ? 'border-success-700 text-success-700'
                  : 'border-gray-500 text-gray-500'
              }`}
            >
              {text}
            </p>
          );
        },
      },
    },
    {
      name: 'actions',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const roleId = tableMeta.rowData[0];
          return (
            <div className="flex gap-2">
              <button
                onClick={() => onEditRole(roleId)}
                className="p-2 hover:bg-gray-200 rounded-full"
                title="Edit Role"
              >
                <FiEdit2 size={16} className="text-secondary-700" />
              </button>
              <button
                onClick={() => onDeleteRole(roleId)}
                className="p-2 hover:bg-gray-200 rounded-full"
                title="Delete Role"
              >
                <FiTrash2 size={16} className="text-danger-500" />
              </button>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    rowsPerPage: pageSize,
    rowsPerPageOptions: [5, 10, 15, 20, 50],
    onChangeRowsPerPage: (numberOfRows) => onPageSizeChange(numberOfRows),
    selectableRows: 'none',
    elevation: 0,
    download: true,
    print: true,
    search: false,
    viewColumns: true,
    filter: true,
  };

  return (
    <div className="w-full overflow-x">
      <MyTable
        title=""
        data={transformedData}
        columns={columns}
        options={options}
      />
    </div>
  );
};

export default UserRolesTable;
